module.exports = __webpack_public_path__ + "static/media/sucursal.ba1ecca9.png";